import { render, staticRenderFns } from "./reporteBanco.vue?vue&type=template&id=040ca2e8&scoped=true"
import script from "./reporteBanco.vue?vue&type=script&lang=ts"
export * from "./reporteBanco.vue?vue&type=script&lang=ts"
import style0 from "./reporteBanco.vue?vue&type=style&index=0&id=040ca2e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040ca2e8",
  null
  
)

export default component.exports